export default __webpack_public_path__ + "static/media/abobora_sergipana.b2b563b7.jpg";